import type { AxiosInstance } from "axios";

import type { CorporateSubscriberResponse } from "./types";

export const fetchCorporateSubscriberTier = async (axios: AxiosInstance, email: string) => {
  const resp = await axios.post<CorporateSubscriberResponse>("/tier", {
    email,
    withCredentials: true,
  });

  return resp.data || "";
};
